// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32QIT","right":"styles_right__2VBEC"};